module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img3.e7e4a75d.jpg";